module.exports = __webpack_public_path__ + "static/img/p-27.ea2281d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-27.png
// module id = Aqe5
// module chunks = 0